import {EventBus} from '@/event-bus.js'
import {getField, updateField} from 'vuex-map-fields';

function initialState() {
    return {
            film: {
                list:{
                    "sortBy":null,
        "descending":true,
        "rowsPerPage":10,
        "page":1,
                }
            }
        };
}

function defaultPagination() {
    return {
        "sortBy":null,
        "descending":true,
        "rowsPerPage":10,
        "page":1,
    }
}

const state = initialState();

// actions

const actions = {

}

// getters
const getters = {
    getField,

};

// mutations
const mutations = {
    updateField,

    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
          state[key] = s[key];
        });
    },
}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
